import { render } from "./UserProfileClosedControl.vue?vue&type=template&id=74702010&ts=true"
import script from "./UserProfileClosedControl.vue?vue&type=script&lang=ts"
export * from "./UserProfileClosedControl.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__